export const purple = {
  1: { value: { base: '{colors.purple.light.1}', _dark: '{colors.purple.dark.1}' } },
  2: { value: { base: '{colors.purple.light.2}', _dark: '{colors.purple.dark.2}' } },
  3: { value: { base: '{colors.purple.light.3}', _dark: '{colors.purple.dark.3}' } },
  4: { value: { base: '{colors.purple.light.4}', _dark: '{colors.purple.dark.4}' } },
  5: { value: { base: '{colors.purple.light.5}', _dark: '{colors.purple.dark.5}' } },
  6: { value: { base: '{colors.purple.light.6}', _dark: '{colors.purple.dark.6}' } },
  7: { value: { base: '{colors.purple.light.7}', _dark: '{colors.purple.dark.7}' } },
  8: { value: { base: '{colors.purple.light.8}', _dark: '{colors.purple.dark.8}' } },
  9: { value: { base: '{colors.purple.light.9}', _dark: '{colors.purple.dark.9}' } },
  10: { value: { base: '{colors.purple.light.10}', _dark: '{colors.purple.dark.10}' } },
  11: { value: { base: '{colors.purple.light.11}', _dark: '{colors.purple.dark.11}' } },
  12: { value: { base: '{colors.purple.light.12}', _dark: '{colors.purple.dark.12}' } },
  a1: { value: { base: '{colors.purple.light.a1}', _dark: '{colors.purple.dark.a1}' } },
  a2: { value: { base: '{colors.purple.light.a2}', _dark: '{colors.purple.dark.a2}' } },
  a3: { value: { base: '{colors.purple.light.a3}', _dark: '{colors.purple.dark.a3}' } },
  a4: { value: { base: '{colors.purple.light.a4}', _dark: '{colors.purple.dark.a4}' } },
  a5: { value: { base: '{colors.purple.light.a5}', _dark: '{colors.purple.dark.a5}' } },
  a6: { value: { base: '{colors.purple.light.a6}', _dark: '{colors.purple.dark.a6}' } },
  a7: { value: { base: '{colors.purple.light.a7}', _dark: '{colors.purple.dark.a7}' } },
  a8: { value: { base: '{colors.purple.light.a8}', _dark: '{colors.purple.dark.a8}' } },
  a9: { value: { base: '{colors.purple.light.a9}', _dark: '{colors.purple.dark.a9}' } },
  a10: { value: { base: '{colors.purple.light.a10}', _dark: '{colors.purple.dark.a10}' } },
  a11: { value: { base: '{colors.purple.light.a11}', _dark: '{colors.purple.dark.a11}' } },
  a12: { value: { base: '{colors.purple.light.a12}', _dark: '{colors.purple.dark.a12}' } },
}
